import FetcherServicesFactory from '../Services/factory.js'
import GetAuthenticationTokenUseCase from './GetAuthenticationTokenUseCase.js'

export default class FetcherUseCasesFactory {
  static getAuthenticationTokenUseCase = ({config}) =>
    new GetAuthenticationTokenUseCase({
      service: FetcherServicesFactory.getAuthenticationTokenService({config})
    })
}
